import { render } from "./DailyReportExternalTrafficTable.vue?vue&type=template&id=5bf980ea"
import script from "./DailyReportExternalTrafficTable.vue?vue&type=script&lang=ts"
export * from "./DailyReportExternalTrafficTable.vue?vue&type=script&lang=ts"

import "./DailyReportExternalTrafficTable.vue?vue&type=style&index=0&id=5bf980ea&lang=scss"
const cssModules = script.__cssModules = {}
import style1 from "./DailyReportExternalTrafficTable.vue?vue&type=style&index=1&id=5bf980ea&lang=scss&module=true"
cssModules["$style"] = style1
script.render = render

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QToggle});
